import type { HTMLAttributes } from 'react'
import { cx } from './cx'
import styles from './Card.module.css'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Padding in px: 24 by default, 20 or 0 for list cards. */
  pad?: 0 | 20 | 24
}

export function Card({ pad = 24, className, ...rest }: CardProps) {
  return <div {...rest} className={cx(styles.card, styles[`pad${pad}`], className)} />
}
